import React, { useState } from "react";
import { observer } from "mobx-react";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import AcxMainTextField from "components/UI/AcxMainTextField";
import Statement from "./Statement";
import { ConditionIndicatorType, FieldOptionsType } from "../../types";

import { compareTypeOptions } from "../../helpers/constants";
import useDebouncedUpdate from "../../hooks/useDebouncedUpdate";

type IfStatementProps = {
    fieldOptions: FieldOptionsType[];
    indicator: ConditionIndicatorType;
    showSeparator?: boolean;
    hasError?: boolean;
    updateIndicator: (key: string, value: string) => void;
    removeIndicator?: () => void;
    label?: string;
};

const IfStatement: React.FC<IfStatementProps> = observer(
    ({
        fieldOptions,
        indicator,
        updateIndicator,
        showSeparator,
        removeIndicator,
        label,
        hasError,
    }) => {
        const [value, setValue] = useState(indicator.value);

        useDebouncedUpdate(() => {
            updateIndicator("value", value);
        }, [value]);

        return (
            <Statement
                remove={removeIndicator}
                separatorLabel={showSeparator ? "OR" : undefined}
                label={label}
            >
                <AcxSelect
                    id={`statement-value-alias-${indicator.id}`}
                    placeholder="Select field"
                    options={fieldOptions}
                    defaultValue={fieldOptions.find(
                        (e) => e.value === indicator.sourceName,
                    )}
                    onChange={(e) => updateIndicator("sourceName", e.value)}
                    error={indicator.hasError && !indicator.sourceName}
                />
                <AcxSelect
                    id={`statement-compare-type-${indicator.id}`}
                    placeholder="Select operator"
                    options={compareTypeOptions}
                    defaultValue={compareTypeOptions.find(
                        (e) => e.value === indicator.compareType,
                    )}
                    onChange={(e) => updateIndicator("compareType", e.value)}
                />
                <AcxMainTextField
                    containerStyle={{ width: "100%" }}
                    id={`statement-value-${indicator.id}`}
                    fullWidth
                    placeholderText="Enter value"
                    isDisabled={indicator.compareType === 0}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    error={hasError && indicator.compareType !== 0 && !value}
                    hideErrorIcon
                />
            </Statement>
        );
    },
);

export default IfStatement;
